// extracted by mini-css-extract-plugin
export var backgroundGradient = "UsK89";
export var backgroundImage = "xzulX";
export var copilotBackgroundGradient = "yEOVh";
export var copilotDarkBackground = "ca3U7";